import { render, staticRenderFns } from "./basic_layout.vue?vue&type=template&id=50832744&scoped=true&"
import script from "./basic_layout.vue?vue&type=script&lang=js&"
export * from "./basic_layout.vue?vue&type=script&lang=js&"
import style0 from "./basic_layout.vue?vue&type=style&index=0&id=50832744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50832744",
  null
  
)

export default component.exports